window.VideoTestimonialGrid = phrase => {
	return {
		val: phrase,
	};
};
